import { render, staticRenderFns } from "./inventoryMovementsSummaryBox.vue?vue&type=template&id=05408dd0&"
import script from "./inventoryMovementsSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./inventoryMovementsSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports